var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"description":_vm.description}},[_c('div',{staticClass:"custom-file mc-icon-picker"},_vm._l((_vm.trackerIcons),function(item){return _c('McIcon',{key:item,class:item == _vm.value ? 'active' : '',attrs:{"sized":"","icon":item},on:{"click":function($event){return _vm.setIcon(item)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }